module.exports = __webpack_public_path__ + "img/training.458f20b0.jpeg";